<template>
  <div class="returnBookdropView">
        <return-bookdrop/>
  </div>
</template>

<script>
import returnBookdrop from '../../components/user/returnBookdrop.vue';
export default {
    components:{returnBookdrop}

}
</script>

<style lang="scss" scoped>

</style>